import axios, { AxiosRequestConfig, Method } from 'axios'
import operations from './operations'
import urls from './urls'
import { createUrl } from '../shared/UrlUtils/urlUtils'

const getCSRFToken = () => {
	const cookies = document.cookie.split('; ')
	const csrfCookie = cookies.find(item => item.startsWith('csrftoken='))
	const csrfToken = csrfCookie?.slice('csrftoken='.length)

	if (csrfToken) {
		return csrfToken
	}

	return ''
}

export default async function playBackendRequestHandler(
	operation: operations,
	data?: any,
	token?: string,
	appendURL?: string,
	queryParams?: Record<string, string | string[]>,
	requestConfig?: AxiosRequestConfig,
) {
	const endpointDetails = urls[operation]
	const csrfToken = getCSRFToken()
	if (endpointDetails) {
		const headers: any = {
			Accept: 'application/json',
			'Content-type': 'application/json',
		}
		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken
		}
		if (token) {
			headers.Authorization = `Bearer ${token}`
		}
		const path = appendURL
			? [endpointDetails.endpoint, appendURL]
			: endpointDetails.endpoint
		const url = createUrl(import.meta.env.VITE_SECDIM_PLAY_BACKEND!, {
			path,
			params: queryParams ?? {},
		})
		return axios({
			method: endpointDetails.type as Method,
			withCredentials: true,
			headers,
			url,
			data,
			...requestConfig,
		})
	}
	throw new Error('Invalid Operation')
}
